import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import { siteConfig } from "@/mocks/site";

const principles = [
  {
    icon: "ri-focus-3-line",
    title: "条理优先",
    desc: "以合集、索引、归档三种形式组织资源，让目录清晰可查，找资源更有条理。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续补全",
    desc: "整理贴会随新资料公开不断更新，补全目录，方便随时查看最新整理。",
  },
  {
    icon: "ri-shield-check-line",
    title: "真实可核",
    desc: "整理信息以官方公布为准，发现错误会及时核对修正，力求资料准确可靠。",
  },
  {
    icon: "ri-hand-heart-line",
    title: "尊重版权",
    desc: "本站仅提供整理索引与目录，资源仅供个人收藏与研究，请勿用于商业用途。",
  },
];

const stats = [
  { value: "12", label: "大类板块" },
  { value: "48", label: "归档条目" },
  { value: "36", label: "持续补全中" },
];

export default function AboutPage() {
  return (
    <Layout>
      <section className="bg-background-950 py-12 md:py-16">
        <div className="container-site">
          <nav className="flex flex-wrap items-center gap-1 text-xs text-background-300" aria-label="面包屑">
            <Link to="/" className="hover:text-background-50">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-background-100">关于我们</span>
          </nav>
          <h1 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-3xl">
            关于{siteConfig.name}
          </h1>
          <p className="mt-3 max-w-2xl text-sm leading-6 text-background-200 md:text-base">
            {siteConfig.description}
          </p>
        </div>
      </section>

      <section className="bg-background-50">
        <div className="container-site py-14 md:py-20">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
            <div>
              <p className="eyebrow">
                <i className="ri-quill-pen-line text-sm"></i>
                品牌介绍
              </p>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                把散落的资源，整理成随手可查的目录
              </h2>
              <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base">
                {siteConfig.name}是一个面向二次元与 ACGN 爱好者的资源整理站。我们相信，好的收藏不只是存下链接，更在于一套清晰、可持续维护的目录。于是我们把资源按照「合集、索引、归档」三种形式系统整理，让每一位收藏者都能按系列或作者快速找到目标，省去零散收藏的麻烦。
              </p>
              <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base">
                无论是动画、漫画、游戏还是轻小说，只要你想批量收藏，直接查归档列表即可。整理贴会持续补全并更新目录，让这里的资料始终保持最新、最有条理。
              </p>
            </div>
            <div className="grid grid-cols-3 gap-4">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-lg border border-background-200/70 bg-background-100/70 p-6 text-center"
                >
                  <p className="font-heading text-3xl font-black text-primary-700 md:text-4xl">
                    {s.value}
                  </p>
                  <p className="mt-2 text-xs text-foreground-500 md:text-sm">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-100">
        <div className="container-site py-14 md:py-20">
          <div className="mb-8 md:mb-10">
            <p className="eyebrow">
              <i className="ri-lightbulb-flash-line text-sm"></i>
              内容原则
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              我们坚持的整理方式
            </h2>
          </div>
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {principles.map((p) => (
              <div
                key={p.title}
                className="rounded-lg border border-background-200/70 bg-background-50 p-6"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-900">
                  <i className={`${p.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-900">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-50">
        <div className="container-site py-14 md:py-20">
          <div className="mb-8 md:mb-10">
            <p className="eyebrow">
              <i className="ri-message-3-line text-sm"></i>
              联系方式
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              有问题或想投稿整理？
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-6 text-foreground-600 md:text-base">
              如果你发现某个系列或作者还没有被整理，或希望优先补全某个板块，欢迎通过邮箱与我们联系。
            </p>
          </div>
          <div className="flex flex-col gap-4 sm:flex-row">
            <div className="flex flex-1 items-center gap-4 rounded-lg border border-background-200/70 bg-background-100/70 p-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-800">
                <i className="ri-mail-line text-xl"></i>
              </span>
              <div>
                <p className="text-sm font-medium text-foreground-800">投稿与建议</p>
                <a
                  href={`mailto:${siteConfig.email}`}
                  className="text-sm text-primary-700 hover:text-primary-800"
                >
                  {siteConfig.email}
                </a>
              </div>
            </div>
            <div className="flex flex-1 items-center gap-4 rounded-lg border border-background-200/70 bg-background-100/70 p-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-100 text-accent-900">
                <i className="ri-archive-line text-xl"></i>
              </span>
              <div>
                <p className="text-sm font-medium text-foreground-800">查看归档</p>
                <Link to="/archive" className="text-sm text-primary-700 hover:text-primary-800">
                  前往归档索引 →
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}